class CustomAPOForm {
  constructor() {
    this.isInstallationInquiryFormSubmitted = false;
    this.isInstallationRequired = false;
    this.hasShopifyForm = false;
    this.InquiryFormId = "gate-installation-inquiry-form-question";
    this.InquiryFormGroupId = "gate-installation-inquiry-form-group";
    this.basePrice = 0;
    this.extrasPrice = 0;
    this.totalPrice = 0;
  }

  init() {
    this.waitForElementsByQuerySelectorAll(
      ".apo-option-group",
      (optionGroups) => {
        this.waitForAllElementsToExsitByQuerySelector(
          [
            '[name="option-avis-0"], [name="option-avis-1"]',
            ".data-variant-option-0, .data-variant-option-1",
            ".apo-option-group",
          ],
          () => {
            // console.log("Custom APO - [All Field Exist]")
            this.customShopifyVariantFields();

            // Add any additional logic needed for .apo-option-group here
          },
        );
      },
    );

    this.waitForBannerSuccess();

    this.initSetBasePrice();
    this.watchBasePrice();
    this.watchExtrasPrice();
    this.relocateCustomOptions();
    this.setupAddonBehavior();
    this.handleProgressBoxStatus();
    this.customiserstyling();
    this.controlEnter();
  }

  controlEnter() {
    (function wireCustomColorOnce() {
      const radiosSel = 'input[name="Colour"]';
      const containerSel = ".custom_color_field";
      const inputSel = `${containerSel} input[type="text"]`;
      const ralRx = /^\s*(?:RAL\s*)?(\d{4})\s*$/i;
      const green = "rgb(34,197,94)";
      const red = "rgb(239,68,68)";

      // Helper: format/validation applied to the text input
      function makeApply(input) {
        return function apply() {
          const v = (input.value || "").trim();
          if (!v) {
            input.style.removeProperty("border-color");
            input.removeAttribute("aria-invalid");
            return;
          }
          const formatOk = ralRx.test(v);
          const lenOk = v.length === 7 || v.length === 8; // "RAL3000" or "RAL 3000"
          const ok = formatOk && lenOk;
          input.style.setProperty(
            "border-color",
            ok ? green : red,
            "important",
          );
          input.setAttribute("aria-invalid", ok ? "false" : "true");
        };
      }

      // Wire the input: add listeners once and store handler so we can remove later
      function wireInputIfNeeded(input) {
        if (!input) return;
        if (input.dataset._ralWired === "1") return;
        const handler = makeApply(input);
        input._ralHandler = handler;
        input.addEventListener("input", handler, { passive: true });
        input.addEventListener("blur", handler, { passive: true });
        input.dataset._ralWired = "1";
        handler(); // initial run
      }

      // Unwire when hiding the container so re-appearing input can be wired fresh
      function unwireInputIfNeeded(input) {
        if (!input) return;
        if (input.dataset._ralWired !== "1") return;
        if (input._ralHandler) {
          input.removeEventListener("input", input._ralHandler);
          input.removeEventListener("blur", input._ralHandler);
          delete input._ralHandler;
        }
        input.dataset._ralWired = "0";
        // clear styling/aria
        input.style.removeProperty("border-color");
        input.removeAttribute("aria-invalid");
      }

      // Show / hide the container based on radios
      function updateVisibility() {
        const radios = Array.from(document.querySelectorAll(radiosSel));
        if (!radios.length) return; // nothing to do until radios exist
        const customRadio = radios.find((r) => r.value === "Custom RAL Colour");
        const container = document.querySelector(containerSel);

        const wantsCustom = !!(customRadio && customRadio.checked);
        if (container) {
          // using inline style to force show/hide regardless of external CSS
          container.style.display = wantsCustom ? "" : "none";

          const input = document.querySelector(inputSel);
          if (wantsCustom) {
            wireInputIfNeeded(input);
          } else {
            unwireInputIfNeeded(input);
          }
        }
      }

      // Poll until radios exist, then attach change listeners and run once
      const pollInterval = 200;
      const timeout = 20000;
      let elapsed = 0;
      const poll = setInterval(() => {
        elapsed += pollInterval;
        const radios = document.querySelectorAll(radiosSel);
        if (!radios.length) {
          if (elapsed >= timeout) clearInterval(poll);
          return;
        }
        clearInterval(poll);

        // Attach single change listener to radios container (delegation) if possible,
        // otherwise attach to each radio.
        const radiosParent =
          radios[0].closest("form") || radios[0].parentElement;
        if (radiosParent) {
          radiosParent.addEventListener("change", (e) => {
            if (e.target && e.target.matches(radiosSel)) updateVisibility();
          });
        } else {
          radios.forEach((r) => r.addEventListener("change", updateVisibility));
        }

        // If the custom container/input might be rendered later (e.g. appears when selected),
        // also watch for it via MutationObserver so wiring happens as soon as it is added.
        const bodyObserver = new MutationObserver(() => {
          // attempt to update visibility/wire if container/input were added
          updateVisibility();
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });

        // initial run to set correct state on load
        updateVisibility();
      }, pollInterval);
    })();

    (function () {
      // Selector for the add-to-cart button you want Enter to trigger
      var ATC_BTN_SELECTOR = ".product-form--atc-button";

      document.addEventListener(
        "keydown",
        function (event) {
          // Only react to plain Enter (avoid Ctrl+Enter, Shift+Enter, Alt+Enter)
          if (
            event.key !== "Enter" ||
            event.ctrlKey ||
            event.altKey ||
            event.metaKey ||
            event.shiftKey
          )
            return;

          var active = document.activeElement;
          if (!active) return;

          // Allow Enter in textareas and contenteditable regions
          var tag = (active.tagName || "").toLowerCase();
          if (tag === "textarea" || active.isContentEditable) return;

          // If the focused element is a button or link, let natural behavior happen
          if (tag === "button" || tag === "a") return;

          // If focused element is an input of type "submit" or "button", ignore
          if (tag === "input") {
            var inputType = (active.getAttribute("type") || "").toLowerCase();
            if (
              inputType === "submit" ||
              inputType === "button" ||
              inputType === "image"
            )
              return;
          }

          // Find the closest form (if any)
          var frm = active.closest ? active.closest("form") : null;

          // Prefer ATC button inside the same form; fallback to first matching on page
          var atc = null;
          if (frm) {
            atc = frm.querySelector(ATC_BTN_SELECTOR);
          }
          if (!atc) {
            atc = document.querySelector(ATC_BTN_SELECTOR);
          }
          if (!atc) return; // nothing to trigger

          // Prevent default Enter behavior (like accidental submit)
          event.preventDefault();
          event.stopPropagation();

          // If button is a <button> or <input type="submit">, try a native click
          try {
            atc.focus({ preventScroll: true });
            atc.click();
          } catch (e) {
            // last-resort: dispatch keyboard event
            var evt = new KeyboardEvent("keydown", {
              key: "Enter",
              bubbles: true,
              cancelable: true,
            });
            atc.dispatchEvent(evt);
          }
        },
        { capture: true },
      );
    })();
  }

  customShopifyVariantFields() {
    // console.log("!important customShopifyVariantFields()");

    const radioButtons = this.getRadioButtons();
    const groupedValues = this.groupRadioButtonValues(radioButtons);

    // Create and append select dropdowns for each group
    Object.keys(groupedValues).forEach((optionIndex) => {
      this.createSelectDropdown(groupedValues[optionIndex], optionIndex);
    });
  }

  getRadioButtons() {
    // Find all radio buttons with names starting with "option-avis-"
    const formElements = document.querySelectorAll(
      'input[name^="option-avis-"]',
    );
    // console.log("Custom APO - [Radio Buttons Found]", formElements);
    return formElements;
  }

  groupRadioButtonValues(radioButtons) {
    const groupedValues = {};

    radioButtons.forEach((radio) => {
      const parentOption = radio.closest(".avis-swatch-option");
      const optionName = parentOption
        .querySelector(".avis-option-name")
        .getAttribute("data-name");
      const optionIndex = parentOption.getAttribute("data-option-index");

      if (!groupedValues[optionIndex]) {
        groupedValues[optionIndex] = { optionName, options: [] };
      }

      groupedValues[optionIndex].options.push({
        value: radio.value,
        dataVariantId: radio.getAttribute("data-variantid"),
        name: radio.name,
      });
    });

    // console.log("!important grouped values", groupedValues)

    return groupedValues;
  }

  createSelectDropdown(group, optionIndex) {
    const selector = `.data-variant-option-${optionIndex}`;
    const divElement = document.querySelector(selector);

    if (divElement) {
      const selectElement = document.createElement("select");
      selectElement.className =
        "avp-productdescfont avp-productoptiontextcolor avp-productoptionbackground custom-apo-select";
      selectElement.required = true;
      selectElement.setAttribute("aria-required", "true");
      // 1️⃣ Add default placeholder
      const defaultOption = document.createElement("option");
      defaultOption.value = "";
      defaultOption.text = "Choose size";
      defaultOption.selected = true;
      defaultOption.disabled = true;
      selectElement.appendChild(defaultOption);

      // 2️⃣ Detect nearest unit type (mm/cm/in/inch)
      const unitMatch = group.options
        .map((item) => item.value.match(/(mm|cm|in|inch|inches)/i))
        .filter(Boolean)[0];
      const detectedUnit = unitMatch ? unitMatch[0] : "";

      // 3️⃣ Populate dropdown with data-unit attributes
      group.options.forEach((item) => {
        const option = document.createElement("option");
        option.value = item.dataVariantId;
        option.text = item.value;

        const firstNumMatch = item.value.match(/^(\d+)/);
        if (firstNumMatch) {
          option.setAttribute("data-unit", firstNumMatch[1]);
        }

        const indexWithoutPrefix = item.name.replace("option-avis-", "");
        option.setAttribute("index", indexWithoutPrefix);
        selectElement.appendChild(option);
      });

      if (detectedUnit) {
        selectElement.dataset.unit = detectedUnit;
      }

      // 4️⃣ Auto-select closest match from input field
      const customSizeInput = document.querySelector(
        '.custom-size-field input[type="text"]',
      );
     if (customSizeInput) {
  customSizeInput.addEventListener("input", () => {
    const inputVal = parseFloat(customSizeInput.value.trim());

    if (isNaN(inputVal)) {
      selectElement.value = "";
      return;
    }

    // Gather all numeric unit values
    const unitOptions = Array.from(selectElement.options)
      .map((opt, idx) => ({
        el: opt,
        value: parseFloat(opt.getAttribute("data-unit")),
        index: idx,
      }))
      .filter((opt) => !isNaN(opt.value));

    // Find the smallest value that is >= inputVal
    let higherOption = null;

    unitOptions.forEach((opt) => {
      if (opt.value >= inputVal) {
        if (higherOption === null || opt.value < higherOption.value) {
          higherOption = opt;
        }
      }
    });

    if (higherOption) {
      selectElement.value = higherOption.el.value;
      this.handleSelectChange({ target: selectElement });
    } else {
      selectElement.value = "";
    }
  });
}

      selectElement.addEventListener("change", (event) =>
        this.handleSelectChange(event),
      );
      divElement.appendChild(selectElement);
    }
  }

  handleSelectChange(event) {
    // console.log('handleSelectChange() Ran');
    // console.log('event target value', event.target.value);
    const selectedVariantId = event.target.value;
    const index = event.target.selectedOptions[0].getAttribute("index");
    // console.log('Index:', index)
    const inputElement = document.querySelector(
      `label[for^="avis-option-value-item-${selectedVariantId}"][for$="${index}"]`,
    );
    // console.log('Input element:', inputElement);
    if (inputElement) {
      // console.log('Input element with data-variantid:', selectedVariantId)
      // console.log('Input element found:', inputElement);
      inputElement.click();
    }

    // Update the variant parameter in the URL
    // const url = new URL(window.location);
    // url.searchParams.set('variant', selectedVariantId);
    // window.history.pushState({}, '', url);

    this.hideDropdownOptions();
  }

  hideDropdownOptions() {
    const dropdownOptions = document.querySelectorAll(
      ".avis-option-values.avis-dropdown-option",
    );
    dropdownOptions.forEach((element) => {
      element.style.display = "none";
    });
  }

  // Waits for  single element to exist by query selector
  waitForElementByQuerySelector(selector, callback) {
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
        observer.disconnect(); // Stop observing once the element is found
        callback(element); // Call the callback with the found element
      }
    });

    observer.observe(document, {
      childList: true,
      subtree: true,
    });
  }
  // Watches for all elements to exist by query selector ()
  waitForElementsByQuerySelectorAll(selector, callback) {
    const observer = new MutationObserver(() => {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        observer.disconnect();
        callback(elements);
      }
    });

    observer.observe(document, {
      childList: true,
      subtree: true,
    });
  }

  // Watches for all elements to exist by query selector
  waitForAllElementsToExsitByQuerySelector(selectors, callback) {
    const observer = new MutationObserver(() => {
      const elements = selectors.map((selector) =>
        document.querySelector(selector),
      );
      const allExist = elements.every((element) => element !== null);

      if (allExist) {
        // console.log("all elements exist", allExist);
        observer.disconnect(); // Stop observing
        callback(elements); // Call the callback with the elements
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  relocateCustomOptions() {
    // wait for the container to exist
    this.waitForElementByQuerySelector(
      "#avpoptions-container__v2",
      (containerEl) => {
        const container =
          containerEl instanceof Element
            ? containerEl
            : document.querySelector("#avpoptions-container__v2");
        if (!container) return;

        try {
          // 1) mark container as osg-progress-boxes (no swiper classes)
          container.classList.add("osg-progress-boxes");

          // Helper to ensure a direct child with className exists and has osg-progress-box
          const ensureChild = (className, insertAfterEl = null) => {
            let el = container.querySelector(`.${className}`);
            if (!el) {
              el = document.createElement("div");
              el.className = className;
              if (insertAfterEl && insertAfterEl.parentNode === container) {
                container.insertBefore(el, insertAfterEl.nextSibling);
              } else {
                container.insertBefore(el, container.firstChild);
              }
            } else {
              // If it's not a direct child, move it to be a direct child
              if (el.parentNode !== container)
                container.insertBefore(el, container.firstChild);
            }
            el.classList.add("osg-progress-box");
            return el;
          };

          // keep order: size first, color second, osg-installation next
          const sizeEl = ensureChild("custom_size");
          const colorEl = ensureChild("custom_color", sizeEl);
          const insEl = ensureChild("osg-installation", colorEl);

          // 3) ensure slides-wrapper exists (but without osg-progress-box class)
          let wrapper = container.querySelector(".slides-wrapper");
          if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.className = "slides-wrapper";
            // we'll insert it into the slidesBox below
          } else {
            // remove osg-progress-box from wrapper if it accidentally has it — slidesBox will hold it
            if (
              wrapper.classList &&
              wrapper.classList.contains("osg-progress-box")
            ) {
              wrapper.classList.remove("osg-progress-box");
            }
          }

          // 3a) ensure slidesBox (.osg-progress-box) exists to contain slides-wrapper and apo-option-group
          let slidesBox = container.querySelector(".slides-osg-box");
          if (!slidesBox) {
            slidesBox = document.createElement("div");
            slidesBox.className = "osg-progress-box slides-osg-box";
          } else {
            // make sure it has osg-progress-box class
            slidesBox.classList.add("osg-progress-box");
          }

          // If wrapper is already in DOM as a direct child of container, replace its spot with slidesBox
          if (wrapper.parentNode === container) {
            // insert slidesBox where wrapper currently is (before wrapper), then move wrapper into slidesBox
            container.insertBefore(slidesBox, wrapper);
            slidesBox.appendChild(wrapper);
          } else {
            // otherwise, insert slidesBox after mechEl (preserve previous placement intent), then append wrapper into it
            if (insEl && insEl.nextSibling)
              container.insertBefore(slidesBox, insEl.nextSibling);
            // if (colorEl && colorEl.nextSibling) container.insertBefore(slidesBox, colorEl.nextSibling);
            else container.appendChild(slidesBox);
            if (wrapper.parentNode && wrapper.parentNode !== slidesBox) {
              wrapper.parentNode.removeChild(wrapper);
            }
            slidesBox.appendChild(wrapper);
          }

          // 4) Move all children except sizeEl, colorEl, mechEl, nav controls, slidesBox into wrapper
          const children = Array.from(container.children);
          children.forEach((child) => {
            if (child === slidesBox) return;
            if (child === sizeEl || child === colorEl || child === insEl)
              return;
            //  if (child === sizeEl || child === colorEl) return;
            if (
              child.classList &&
              (child.classList.contains("slider-next") ||
                child.classList.contains("slider-prev"))
            )
              return;
            if (child.classList && child.classList.contains("summary")) return;
            // move everything else into wrapper (which now lives inside slidesBox)
            wrapper.appendChild(child);
          });

          // ===== New additions (minimal change) =====
          // A) ensure slides-wrapper has sibling .apo-option-group that is a direct child of slidesBox
          let apoGroup = slidesBox.querySelector(".apo-option-group");
          if (!apoGroup) {
            // if there's an apo-group somewhere else, prefer that
            apoGroup =
              container.querySelector(".apo-option-group") ||
              document.createElement("div");
            apoGroup.className = "apo-option-group";
          }
          // Pick subtitle text based on whether this product has mechanism options
          const hasMechanism = !!document.querySelector(".mechanism-type");
          const subtitleText = hasMechanism
            ? "Select mechanism first and scroll for more options."
            : "Select add-ons and scroll for more options";

          // ensure title exists and correct text for Addons
          let title = apoGroup.querySelector(".avp-option-title");
          if (!title) {
            title = document.createElement("div");
            title.className = "avp-option-title";

            const span = document.createElement("span");
            span.className = "apo-title";
            span.textContent = "Addons (Optional)";

            // Add subtitle hint
            const subtitle = document.createElement("span");
            subtitle.className = "apo-subtitle";
            subtitle.textContent = subtitleText;

            // Add mechanism tag placeholder (will be updated by mechanism selection JS)
            const mechanismTag = document.createElement("span");
            mechanismTag.className = "mechanism-tag";
            mechanismTag.id = "addons-mechanism-tag";

            title.appendChild(span);
            title.appendChild(subtitle);
            title.appendChild(mechanismTag);
            apoGroup.insertBefore(title, apoGroup.firstChild);
          } else {
            // ensure the span exists and update text
            let span = title.querySelector(".apo-title");
            if (!span) {
              span = document.createElement("span");
              span.className = "apo-title";
              title.insertBefore(span, title.firstChild);
            }
            span.textContent = "Addons (Optional)";

            // ensure subtitle exists
            let subtitle = title.querySelector(".apo-subtitle");
            if (!subtitle) {
              subtitle = document.createElement("span");
              subtitle.className = "apo-subtitle";
              subtitle.textContent = subtitleText;
              title.appendChild(subtitle);
            } else {
              subtitle.textContent = subtitleText;
            }

            // ensure mechanism tag placeholder exists
            let mechanismTag = title.querySelector(".mechanism-tag");
            if (!mechanismTag) {
              mechanismTag = document.createElement("span");
              mechanismTag.className = "mechanism-tag";
              mechanismTag.id = "addons-mechanism-tag";
              title.appendChild(mechanismTag);
            }
          }

          // move apoGroup to be immediate first child of slidesBox (so order: apoGroup, slides-wrapper)
          if (apoGroup.parentNode !== slidesBox) {
            if (apoGroup.parentNode) apoGroup.parentNode.removeChild(apoGroup);
            slidesBox.insertBefore(apoGroup, slidesBox.firstChild);
          } else if (slidesBox.firstChild !== apoGroup) {
            slidesBox.insertBefore(apoGroup, slidesBox.firstChild);
          }

          // ensure slides-wrapper comes immediately after apoGroup
          if (slidesBox.children.length >= 2) {
            if (slidesBox.children[1] !== wrapper)
              slidesBox.insertBefore(wrapper, apoGroup.nextSibling);
          } else {
            slidesBox.appendChild(wrapper);
            if (slidesBox.children[0] !== apoGroup)
              slidesBox.insertBefore(apoGroup, slidesBox.firstChild);
          }

          // // scroll hint above addon cards (inside apoGroup, after the title)
          // if (!apoGroup.querySelector(".addons-scroll-hint")) {
          //   const scrollHint = document.createElement("p");
          //   scrollHint.className = "addons-scroll-hint";
          //   scrollHint.textContent = "Scroll to see all add-ons";
          //   apoGroup.appendChild(scrollHint);
          // }

          // ----- after you ensure wrapper is inserted into slidesBox -----
          /* hide parent osg box only when there are no .avp-option OR when the only .avp-option(s) are .blank
   also toggles hiding of .custom_color::after via a data attribute and one-time style injection */
          (function hideIfOnlyBlankOrNone() {
            const STYLE_ID = "hide-custom-color-after-style";
            if (!document.getElementById(STYLE_ID)) {
              const style = document.createElement("style");
              style.id = STYLE_ID;
              style.textContent =
                '.custom_color[data-hide-after="1"]::after { display: none !important; }';
              document.head.appendChild(style);
            }

            // wrapper is your .slides-wrapper element from earlier
            const avpNodes = Array.from(
              wrapper.querySelectorAll(".avp-option"),
            );
            const hasAnyAvp = avpNodes.length > 0;
            const hasBlankAvp = avpNodes.some((n) =>
              n.classList.contains("blank"),
            );
            const hasNonBlankAvp = avpNodes.some(
              (n) => !n.classList.contains("blank"),
            );

            // hide only when no avp OR when there are avp nodes but none are non-blank
            const shouldHide = !hasAnyAvp || (hasBlankAvp && !hasNonBlankAvp);

            // find the containing osg progress box (closest ancestor)
            const osgBox = wrapper.closest(".osg-progress-box.slides-osg-box");
            if (!osgBox) return;

            if (shouldHide) {
              osgBox.style.setProperty("display", "none", "important");
              osgBox.setAttribute("aria-hidden", "true");
            } else {
              osgBox.style.removeProperty("display");
              osgBox.removeAttribute("aria-hidden");
            }

            // find a sibling .custom_color in the same parent and toggle the attribute used to hide ::after
            const parent = osgBox.parentElement;
            if (!parent) return;
            const customColorSibling = parent.querySelector(".custom_color");

            if (customColorSibling) {
              if (shouldHide) {
                customColorSibling.setAttribute("data-hide-after", "1");
              } else {
                customColorSibling.removeAttribute("data-hide-after");
              }
            }
          })();

          // B) create sibling "osg-progress-box summary" and ensure .apo-option-group is the parent of .avp-option-title
          let summaryEl = container.querySelector(".osg-progress-box.summary");
          if (!summaryEl) {
            summaryEl = document.createElement("div");
            summaryEl.className = "osg-progress-box summary";
          }

          // ensure .apo-option-group exists as direct child of summaryEl
          let summaryApo = summaryEl.querySelector(".apo-option-group");
          if (!summaryApo) {
            summaryApo = document.createElement("div");
            summaryApo.className = "apo-option-group";
            summaryEl.insertBefore(summaryApo, summaryEl.firstChild);
          }

          // ensure .avp-option-title exists inside summaryApo and contains span.apo-title
          let summaryTitle = summaryApo.querySelector(".avp-option-title");
          if (!summaryTitle) {
            summaryTitle = document.createElement("div");
            summaryTitle.className = "avp-option-title";
            const span = document.createElement("span");
            span.className = "apo-title";
            span.textContent = "Summary";
            summaryTitle.appendChild(span);
            summaryApo.insertBefore(summaryTitle, summaryApo.firstChild);
          } else {
            let span = summaryTitle.querySelector(".apo-title");
            if (!span) {
              span = document.createElement("span");
              span.className = "apo-title";
              summaryTitle.insertBefore(span, summaryTitle.firstChild);
            }
            span.textContent = "Summary";
          }

          // Insert summaryEl after the slidesBox (if not already placed there)
          if (slidesBox.nextSibling !== summaryEl) {
            if (summaryEl.parentNode && summaryEl.parentNode !== container) {
              summaryEl.parentNode.removeChild(summaryEl);
            }
            container.insertBefore(summaryEl, slidesBox.nextSibling);
          }

          (function () {
            const wrapper = document.querySelector(".slides-wrapper");
            if (!wrapper) return;

            let btn = document.querySelector(".apo-no-addons-btn");
            if (!btn) {
              btn = document.createElement("button");
              btn.type = "button";
              btn.className = "apo-no-addons-btn active";
              btn.textContent = "No Thanks, I don’t want addons";
              wrapper.insertAdjacentElement("afterend", btn);
            }

            const inputsSelector =
              'input[type="checkbox"], input[type="radio"]';

            // Uncheck all addon inputs and collapse sections
            const deselectAllAddons = ({ scroll = true } = {}) => {
              const inputs = Array.from(
                wrapper.querySelectorAll(inputsSelector),
              );
              inputs.forEach((i) => {
                if (i.checked) {
                  i.checked = false;
                  i.dispatchEvent(new Event("change", { bubbles: true }));
                }
              });

              const box = wrapper.closest(".osg-progress-box");
              if (box) {
                box.classList.remove("apo-show");
                box.querySelectorAll(".addon-show").forEach((opt) => {
                  opt.classList.remove("addon-show");
                });
                box.style.height = "";

                if (scroll) {
                  const apoGroup = box.querySelector(".apo-option-group");
                  if (apoGroup) {
                    apoGroup.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }
                }
              }

              btn.classList.add("active");
            };

            const removeIfAnySelected = () => {
              const any = Array.from(
                wrapper.querySelectorAll(inputsSelector),
              ).some((i) => i.checked);
              if (any) btn.classList.remove("active");
            };

            btn.addEventListener("click", () => {
              deselectAllAddons();
              btn.focus();
            });

            // handle normal user interaction (change bubbles)
            wrapper.addEventListener("change", removeIfAnySelected, true);

            // handle clicks on custom controls that may not trigger "change" immediately
            wrapper.addEventListener(
              "click",
              () => setTimeout(removeIfAnySelected, 0),
              true,
            );

            // fallback for programmatic attribute-only changes
            const mo = new MutationObserver(removeIfAnySelected);
            mo.observe(wrapper, {
              attributes: true,
              subtree: true,
              attributeFilter: ["checked"],
            });

            // Default to "no addons" on page load, after Avis app finishes init
            setTimeout(() => deselectAllAddons({ scroll: false }), 200);
          })();

          (function moveInstallationForm() {
            const form = document.querySelector(
              "#gate-installation-inquiry-form-wrapper",
            );
            const target = document.querySelector("#install-form-wrap");

            if (!form || !target) return; // stop if either is missing

            // if it's already inside, do nothing
            if (form.parentElement === target) return;

            target.appendChild(form);
          })();

          (function wireInstallationRadios(root = document) {
            const selector =
              '.installation-form-trigger input[type="radio"][name="Gate Installation"]';

            // helper: toggle the installation form inside the closest .apo-group-child
            const applyForRadio = (radio) => {
              if (!(radio instanceof Element)) return;
              const apo = radio.closest(".apo-group-child");
              if (!apo) return;
              const target = apo.querySelector(
                "#gate-installation-inquiry-form",
              );
              if (!target) return;

              // decide: first radio = no (hide), others = yes (show)
              const group = Array.from(
                apo.querySelectorAll(
                  `input[type="radio"][name="${radio.name}"]`,
                ),
              );
              const idx = group.indexOf(radio);
              const shouldShow =
                idx > 0 || /^(yes|y|true)$/i.test((radio.value || "").trim());

              target.style.display = shouldShow ? "block" : "none";
              target.setAttribute("aria-hidden", shouldShow ? "false" : "true");
            };

            // wire existing radios
            Array.from(root.querySelectorAll(selector)).forEach((r) => {
              r.addEventListener("change", () => applyForRadio(r), false);
              // apply initial state if checked
              if (r.checked) applyForRadio(r);
            });

            // delegated fallback for radios injected later
            document.addEventListener(
              "change",
              (ev) => {
                const el = ev.target;
                if (el && el.matches && el.matches(selector)) {
                  // apply immediately and also ensure a direct listener is attached
                  applyForRadio(el);
                  if (!el.__installation_wired) {
                    el.addEventListener(
                      "change",
                      () => applyForRadio(el),
                      false,
                    );
                    el.__installation_wired = true;
                  }
                }
              },
              true,
            );
          })();
        } catch (err) {
          console.warn("relocateCustomOptions error", err);
        }
      },
    );
  }

  watchBasePrice() {
    this.waitForElementByQuerySelector("[data-price]", (element) => {
      const targetNode = document.querySelector(".price__current");

      if (!targetNode) {
        // console.error('Element not found: .price__current');
        return;
      }

      // Define the callback for mutations
      const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData"
          ) {
            const moneyNode = targetNode.querySelector("span.money");
            if (moneyNode) {
              const newValue = parseFloat(
                moneyNode.innerText.replace("£", "").replace(",", ""),
              );
              if (!isNaN(newValue)) {
                this.basePrice = newValue;
                // console.log('The inner text has changed to: ', moneyNode.innerText);
                this.totalPrice = this.basePrice + this.extrasPrice;
                this.setFormBasePrice(this.totalPrice);
              }
            }
          }
        }
      };

      // Create a MutationObserver instance
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, {
        childList: true,
        characterData: true,
        subtree: true,
      });

      // console.log('Observer is now watching for changes to .price__current.');

      return observer; // Return the observer if needed
    });
  }

  setFormBasePrice(price) {
    document.querySelector(".order-form-price").innerText =
      "£" +
      price.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  }

  initSetBasePrice() {
    this.waitForElementByQuerySelector("[data-price]", (element) => {
      const basePrice = parseFloat(
        element.innerText.replace("£", "").replace(",", ""),
      );
      this.basePrice = basePrice;
      this.setFormBasePrice(basePrice);
    });
  }

  customiserstyling() {
    (function moveAllTotals() {
      // Adjust this selector to the product container if you have one, e.g. '.product-item'
      const totals = Array.from(document.querySelectorAll(".total-price-box"));

      totals.forEach((total) => {
        // find a nearby .product-form--atc: prefer same parent, then closest ancestor search
        let atc =
          total.parentElement.querySelector(".product-form--atc") ||
          total.closest(".product-item")?.querySelector(".product-form--atc") ||
          document.querySelector(".product-form--atc"); // fallback to first on page

        if (atc && atc.parentNode) {
          atc.parentNode.insertBefore(total, atc);
        } else {
          console.warn("No matching .product-form--atc for", total);
        }
      });
    })();
    (function moveDetailsForDevices() {
      const MQ = "(max-width: 767px)";
      const mq = window.matchMedia(MQ);
      const originalPos = new WeakMap();

      const findGalleryFor = (details) =>
        details.parentElement?.querySelector(".product-gallery") ||
        details.closest(".product-item")?.querySelector(".product-gallery") ||
        document.querySelector(".product-gallery");

      const move = () => {
        document.querySelectorAll(".product-details").forEach((details) => {
          const gallery = findGalleryFor(details);
          if (!gallery) return;

          // save original position once
          if (!originalPos.has(details)) {
            originalPos.set(details, {
              parent: details.parentNode,
              nextSibling: details.nextSibling,
            });
          }

          const outer = gallery.parentNode;
          const warranty = outer.querySelector(".product-warranty-above-gallery");

          // Place warranty first, then gallery, then details after gallery
          if (warranty) {
            outer.insertBefore(warranty, outer.firstChild);
            outer.insertBefore(gallery, warranty.nextSibling);
            outer.insertBefore(details, gallery.nextSibling);
          } else {
            // No warranty box: put details after gallery
            outer.insertBefore(details, gallery.nextSibling);
          }
        });
      };

      const restore = () => {
        document.querySelectorAll(".product-details").forEach((details) => {
          const info = originalPos.get(details);
          if (!info || !info.parent) return;

          // already restored?
          if (
            details.parentNode === info.parent &&
            details.nextSibling === info.nextSibling
          )
            return;

          // insert before saved nextSibling, or append if not available
          if (info.nextSibling && info.nextSibling.parentNode === info.parent) {
            info.parent.insertBefore(details, info.nextSibling);
          } else {
            info.parent.appendChild(details);
          }
        });
      };

      const apply = () => {
        if (mq.matches) move();
        else restore();
      };

      // initial run
      apply();

      // media query change listener (preferred)
      if (mq.addEventListener) mq.addEventListener("change", apply);
      else if (mq.addListener) mq.addListener(apply);

      // debounce resize as a fallback to catch browsers that don't fire mq change reliably
      let t;
      window.addEventListener("resize", () => {
        clearTimeout(t);
        t = setTimeout(apply, 120);
      });
    })();
  }

  watchExtrasPrice() {
    // console.log("test");
    this.waitForElementByQuerySelector(
      "#avp-productoption-totalpriceadd",
      (element) => {
        // console.log('Element found: #avp-productoption-total-add');
        const targetNode = document.querySelector(
          "#avp-productoption-total-add",
        );
        // console.log('Target node:', targetNode);

        if (!targetNode) {
          // console.error('Element not found: #avp-productoption-total-add');
          return;
        }

        // Define the callback for mutations
        const callback = (mutationsList) => {
          for (const mutation of mutationsList) {
            if (
              mutation.type === "childList" ||
              mutation.type === "characterData"
            ) {
              const moneyNode = targetNode.querySelector(
                "#avp-productoption-totalpriceadd",
              );
              if (moneyNode) {
                const newValue = parseFloat(
                  moneyNode.innerText.replace("£", "").replace(",", ""),
                );
                //   console.log(newValue);
                if (!isNaN(newValue)) {
                  this.extrasPrice = newValue;
                  console.log("Extra price", moneyNode.innerText);

                  this.ExtrasPrice = newValue;
                  this.totalPrice = this.basePrice + this.extrasPrice;
                  this.setFormBasePrice(this.totalPrice);
                }
              }
            }
          }
        };

        // Create a MutationObserver instance
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, {
          childList: true,
          characterData: true,
          subtree: true,
        });

        // console.log('Observer is now watching for changes to #avp-productoption-total-add');

        return observer; // Return the observer if needed
      },
    );
  }

  setupAddonBehavior() {
    if (typeof this.waitForElementByQuerySelector !== "function") return;

    this.waitForElementByQuerySelector(
      "#avpoptions-container__v2",
      (container) => {
        if (!container || container.dataset._addonBehaviorInit === "true")
          return;
        container.dataset._addonBehaviorInit = "true";

        const OFFSET = 250; // px
        const inputsSelector = 'input[type="radio"]';

        const applyBoxHeight = (box) => {
          const shown = box.querySelector(".avp-option.addon-show");
          if (!shown) {
            box.style.height = "";
            return;
          }

          const group = shown.querySelector(".ap-options__optiongroup");
          if (!group) {
            box.style.height = "";
            return;
          }

          // measure after layout to get stable values
          requestAnimationFrame(() => {
            // Save previous inline height (may be '')
            const prevInline = box.style.height;

            // Clear inline height so measurement is of natural content
            box.style.height = "";

            // Force layout read; prefer scrollHeight for stable content height
            const measured = Math.ceil(
              group.scrollHeight || group.getBoundingClientRect().height,
            );
            const desired = measured + OFFSET;

            // Determine current height: prefer numeric from previous inline, otherwise computed
            const inlineNumeric = parseFloat(prevInline);
            const computedNumeric = parseFloat(getComputedStyle(box).height);
            const current = Number.isFinite(inlineNumeric)
              ? inlineNumeric
              : Number.isFinite(computedNumeric)
                ? computedNumeric
                : 0;

            // Set only if meaningfully different to avoid tiny reflows / accumulation
            if (Math.abs(current - desired) > 1) {
              box.style.height = desired + "px";
            } else {
              // restore previous inline if it existed, otherwise keep '' so CSS controls it
              box.style.height = prevInline || "";
            }
          });
        };

        const clickHandler = (ev) => {
          const title = ev.target.closest(".avp-option-title");
          if (!title) return;

          const avpOption = title.closest(".avp-option");
          if (!avpOption) return;

          const box = avpOption.closest(".osg-progress-box");
          if (!box) return;
          if (
            box.classList.contains("custom_size") ||
            box.classList.contains("custom_color")
          )
            return;

          box.classList.remove("apo-show");

          // exclusive: remove addon-show from siblings, add to clicked
          box.querySelectorAll(".avp-option").forEach((opt) => {
            if (opt === avpOption) return;
            opt.classList.remove("addon-show");
          });
          avpOption.classList.add("addon-show");

          // measure after DOM changes settle
          applyBoxHeight(box);

          ev.stopPropagation();
        };

        const changeHandler = (ev) => {
          const input = ev.target;
          if (!input || !input.matches(inputsSelector)) return;
          if (!input.closest(".apo-swatch-wrapper")) return;

          const box = input.closest(".osg-progress-box");
          if (!box) return;

          // allow any DOM class changes to happen first, then re-measure
          requestAnimationFrame(() => applyBoxHeight(box));
        };

        container.addEventListener("click", clickHandler, false);
        container.addEventListener("change", changeHandler, true);
        window.addEventListener("resize", () => {
          container
            .querySelectorAll(".osg-progress-box")
            .forEach(applyBoxHeight);
        });
      },
    );
  }

  handleProgressBoxStatus() {
    // Wait for boxes to exist
    const checkExist = setInterval(() => {
      const progressBoxes = document.querySelectorAll(".osg-progress-box");
      if (!progressBoxes.length) return;

      clearInterval(checkExist);

      // Attach listeners once
      progressBoxes.forEach((box, index) => {
        box.addEventListener("click", (e) => updateStatus(index));
        box.addEventListener("change", (e) => updateStatus(index));
      });

      function updateStatus(activeIndex) {
        progressBoxes.forEach((b, i) => {
          // Clear old states
          b.classList.remove("status-success", "status-progress");

          // Mark all before active as success
          if (i < activeIndex) {
            b.classList.add("status-success");
          }
          // Mark current as progress
          else if (i === activeIndex) {
            b.classList.add("status-progress");
          }
          // All after active remain plain
        });
      }
    }, 200);
  }

  waitForBannerSuccess() {
    ShadowDOMUtils.waitForElementByQuerySelector(
      '[data-testid="banner-success"]',
      (element) => {
        // console.log('Banner success element is now in the DOM:', element);
        // dataLayer.push({'event':'osg-lead-form-submitted'});
        Shopify.analytics.publish("osg-lead-form-submitted");
        const apoElements = document.getElementsByClassName("apo-option-group");
        if (apoElements.length > 0) {
          apoElements[0].parentElement.classList.add("apo-show");
        }
        // document.getElementById("gate-installation-inquiry-form").style.display = 'none';
        // document.getElementById("gate-installation-inquiry-form-questions").style.display = 'none';
        document.querySelector(".step-name").innerHTML +=
          '<span class="inquiry-success">Inquiry Successfully Sent</span>';
        // this.removeClickHandlerInquiryForm()
      },
    );
  }
}

const myCustomAPOForm = new CustomAPOForm();
myCustomAPOForm.init();

const styles = `

    [class^="_textHeading_"] {
        display: none;
        color: red !important;
        font-size: 20px;
    }


    [class^="_formSubmitButton_"] {
        width: 100px !important;
        background: green !important;
        border: 1px solid darkgreen !important;
    }
    #form-container-ref > :first-child {
        justify-items: start !important;
    }
    [class^="_textBody_"] {
        text-align: left !important;
        font-size: 16px !important;
        font-family: Gill Sans Nova,sans-serif !important;
    }
    section[class^="_formHeader_"] {
        margin: 15px 0px 15px 0px !important;
    }
`;

ShadowDOMUtils.waitForShadowHostAndAddStyles("#app-embed", styles);
